var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"dense":_vm.$vuetify.breakpoint.mobile}},[_c('v-col',[_c('webcam-panel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }